<template>
  <v-container fluid grid-list-md>
    <div align="left" v-if=this.error>
      <v-alert :value="true" outline color="error" icon="warning">{{ this.error }}</v-alert>
      <br>
    </div>    
    <div align="left">List of Active Devices ({{ items.length }}) <v-btn small icon @click="dataRefresh"><v-icon>refresh</v-icon></v-btn>
      <br>
    </div>    
    <v-data-iterator
      content-tag="v-layout"
      row
      wrap
      :items="items"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
    >
      <v-flex
        slot="item"
        slot-scope="props"
        xs12
        sm6
        md4
        lg3
      >
        <v-card>
          <tbody>
            <tr>
              <th class="text-xs-left">{{ props.item.residentLabel }}<span style="color: red;">{{ props.item.resident }}</span></th>
            </tr>
            <tr>
              <th class="text-xs-left">{{ props.item.unitLabel }}<span style="color: red;">{{ props.item.unitNum }}</span></th>
            </tr>
            <tr>
              <th class="text-xs-left">{{ props.item.deviceSerialLabel }}<span style="color: blue;">{{ props.item.deviceSerial }}</span></th>
            </tr>
            <tr>
              <th class="text-xs-left">&nbsp;</th>
            </tr>
          </tbody>  
          <v-divider></v-divider>
          <tbody>
            <tr>
              <th class="text-xs-left">Measurement</th>
              <th class="text-xs-center">Value</th>
              <th class="text-xs-center">Average</th>
              <th class="text-xs-right">Received At</th>
            </tr>
            <tr v-if=props.item.heartRateTime>
              <td class="text-xs-left" width="22%">Heart Rate</td>
              <td class="text-xs-center" width="15%">{{ props.item.heartRateValue }}</td>
              <td class="text-xs-center" width="15%">{{ props.item.heartRateAve }}</td>
              <td class="text-xs-right" width="48%">{{ unixtimeAt(props.item.heartRateTime) }}</td>
            </tr>
            <tr v-else>
              <td class="text-xs-left" width="22%">Heart Rate</td>
              <td class="text-xs-center" width="15%">{{ props.item.heartRateValue }}</td>
              <td class="text-xs-center" width="15%">{{ props.item.heartRateValue }}</td>
              <td class="text-xs-right" width="48%">&nbsp;</td>
            </tr>
            <tr v-if=props.item.motionAccelSum>
              <td class="text-xs-left" width="22%">M-Acceler</td>
              <td class="text-xs-center" width="15%">{{ props.item.motionAccelSum }}</td>
              <td class="text-xs-center" width="15%">{{ props.item.motionAccelAve }}</td>
              <td class="text-xs-right" width="48%">{{ unixtimeAt(props.item.motionTime) }}</td>
            </tr>
            <tr v-else>
              <td class="text-xs-left" width="22%">M-Acceler</td>
              <td class="text-xs-center" width="15%">{{ props.item.motionAccelSum }}</td>
              <td class="text-xs-center" width="15%">{{ props.item.motionAccelAve }}</td>
              <td class="text-xs-right" width="48%">&nbsp;</td>
            </tr>
            <tr v-if=props.item.motionGravSum>
              <td class="text-xs-left" width="22%">M-Gravity</td>
              <td class="text-xs-center" width="15%">{{ props.item.motionGravSum }}</td>
              <td class="text-xs-center" width="15%">{{ props.item.motionGravAve }}</td>
              <td class="text-xs-right" width="48%">{{ unixtimeAt(props.item.motionTime) }}</td>
            </tr>
            <tr v-else>
              <td class="text-xs-left" width="22%">M-Gravity</td>
              <td class="text-xs-center" width="15%">{{ props.item.motionGravSum }}</td>
              <td class="text-xs-center" width="15%">{{ props.item.motionGravAve }}</td>
              <td class="text-xs-right" width="48%">&nbsp;</td>
            </tr>
            <tr v-if=props.item.motionRotateSum>
              <td class="text-xs-left" width="22%">M-Rotation</td>
              <td class="text-xs-center" width="15%">{{ props.item.motionRotateSum }}</td>
              <td class="text-xs-center" width="15%">{{ props.item.motionRotateAve }}</td>
              <td class="text-xs-right" width="48%">{{ unixtimeAt(props.item.motionTime) }}</td>
            </tr>
            <tr v-else>
              <td class="text-xs-left" width="22%">M-Rotation</td>
              <td class="text-xs-center" width="15%">{{ props.item.motionRotateSum }}</td>
              <td class="text-xs-center" width="15%">{{ props.item.motionRotateAve }}</td>
              <td class="text-xs-right" width="48%">&nbsp;</td>
            </tr>
            <tr v-if=props.item.batteryTime>
              <td class="text-xs-left" width="22%">Battery Level</td>
              <td class="text-xs-center" width="15%">{{ props.item.batteryLevel }}</td>
              <td class="text-xs-center" width="15%">{{ props.item.batteryLevelAve }}</td>
              <td class="text-xs-right" width="48%">{{ unixtimeAt(props.item.batteryTime) }}</td>
            </tr>
            <tr v-else>
              <td class="text-xs-left" width="22%">Battery Level</td>
              <td class="text-xs-center" width="15%">{{ props.item.batteryLevel }}</td>
              <td class="text-xs-center" width="15%">{{ props.item.batteryLevelAve }}</td>
              <td class="text-xs-right" width="48%">&nbsp;</td>
            </tr>
            <tr v-if=props.item.wifiTime>
              <td class="text-xs-left" width="22%">WiFi SSID</td>
              <td class="text-xs-left" colspan="2">{{ props.item.wifiSsid }}</td>
              <td class="text-xs-right" width="48%">{{ unixtimeAt(props.item.wifiTime) }}</td>
            </tr>
            <tr v-else>
              <td class="text-xs-left" width="22%">WiFi SSID</td>
              <td class="text-xs-left" colspan="2">{{ props.item.wifiSsid }}</td>
              <td class="text-xs-right" width="48%">&nbsp;</td>
            </tr>
            <tr v-if=props.item.wifiTime>
              <td class="text-xs-left" width="22%">WiFi Strength</td>
              <td class="text-xs-center" width="15%">{{ props.item.wifiRssi }}</td>
              <td class="text-xs-center" width="15%">&nbsp;</td>
              <td class="text-xs-right" width="48%">{{ unixtimeAt(props.item.wifiTime) }}</td>
            </tr>
            <tr v-else>
              <td class="text-xs-left" width="22%">WiFi Strength</td>
              <td class="text-xs-center" width="15%">{{ props.item.wifiRssi }}</td>
              <td class="text-xs-center" width="15%">&nbsp;</td>
              <td class="text-xs-right" width="48%">&nbsp;</td>
            </tr>
          </tbody>
        </v-card>
      </v-flex>
    </v-data-iterator>
    <div class="red white--text subheading">{{ error }}</div>
  </v-container>
</template>
<script>
  import mixins from '@/mixins.js'
  import DeviceService from '@/services/DeviceService'
  import DeviceHeartRateService from '@/services/DeviceHeartRateService'
  import DeviceMotionService from '@/services/DeviceMotionService'
  import DeviceBatteryService from '@/services/DeviceBatteryService'
  import CareUserService from '@/services/CareUserService'
  import DeviceWifiService from '@/services/DeviceWifiService'
  import moment from 'moment'

  export default {
    data(){
      return {
        rowsPerPageItems: [8, 16, {"text": "All", "value": -1}],
        pagination:{
          rowsPerPage: -1
        },
        error: '',
        items: [],
      }
    },
    mixins: [mixins],
    async mounted() {
      try {
        this.error = ''
        this.items = []
        this.showProgress = true
        var devices = (await DeviceService.index()).data
        if (devices) {
          for (var i = 0; i < devices.length; i++) {
            var b_alert = false
            var heart_rate_value = null
            var heart_rate_ave = null
            var heart_rate_time = null
            var motion_accel_sum = null
            var motion_accel_ave = null
            var motion_grav_sum = null
            var motion_grav_ave = null
            var motion_rota_sum = null
            var motion_rota_ave = null
            var motion_time = null
            var battery_level = null
            var battery_level_ave = null
            var battery_time = null
            var wifi_ssid = null
            var wifi_time = null
            var wifi_rssi = null
            var deviceheartrate = (await DeviceHeartRateService.show({deviceId: devices[i].deviceId, latest: true})).data
            var devicemotion = (await DeviceMotionService.show({deviceId: devices[i].deviceId,latest: true})).data
            var devicebattery = (await DeviceBatteryService.show({deviceId: devices[i].deviceId,latest: true})).data
            var devicewifi = (await DeviceWifiService.show({deviceId: devices[i].deviceId,latest: true})).data
            console.log('mounted()--deviceId[' + devices[i].deviceId + ']')
            if (deviceheartrate[0]) {
              console.log('mounted()--deviceId[' + devices[i].deviceId + '],deviceheartrate[0] is not null')
              b_alert = true
              if (deviceheartrate[0].heartRate) {
                heart_rate_value = deviceheartrate[0].heartRate
              }
              if (deviceheartrate[0].createdAt) {
                heart_rate_time = deviceheartrate[0].createdAt
              }
            }
            if (devicemotion[0]) {
              console.log('mounted()--deviceId[' + devices[i].deviceId + '],devicemotion[0] is not null')
              b_alert = true
              if (devicemotion[0].accelSum) {
                motion_accel_sum = devicemotion[0].accelSum
              }
              if (devicemotion[0].gravitySum) {
                motion_grav_sum = devicemotion[0].gravitySum
              }
              if (devicemotion[0].rotationSum) {
                motion_rota_sum = devicemotion[0].rotationSum
              }
              if (devicemotion[0].createdAt) {
                motion_time = devicemotion[0].createdAt
              }
            }
            if (devicebattery[0]) {
              console.log('mounted()--deviceId[' + devices[i].deviceId + '],devicebattery[0] is not null')
              b_alert = true
              if (devicebattery[0].batteryLevel) {
                battery_level = devicebattery[0].batteryLevel
              }
              if (devicebattery[0].createdAt) {
                battery_time = devicebattery[0].createdAt
              }
            }
            if (devicewifi[0]) {
              console.log('dataRefresh()--deviceId[' + devices[i].deviceId + '],devicewifi[0] is not null')
              b_alert = true
              if (devicewifi[0].ssid) {
                wifi_ssid = devicewifi[0].ssid
              }
              if (devicewifi[0].rssi) {
                wifi_rssi = devicewifi[0].rssi
              }
              if (devicewifi[0].createdAt) {
                wifi_time = devicewifi[0].createdAt
              }
            }
            if (b_alert) {
              var careUserId = devices[i].careUserId
              var careuser = (await CareUserService.show({careUserId})).data
              var first_name = ''
              var last_name = ''
              var unit_num = ''
              if (careuser) {
                first_name = careuser.firstName
                last_name = careuser.lastName
                if (careuser.address) {
                  unit_num = careuser.address.unitNumber
                }
              }
              var item = {
                deviceId: devices[i].deviceId,
                residentLabel: 'Resident Name: ',
                resident:  first_name + ' ' + last_name,
                unitLabel: 'Unit: ',
                unitNum: unit_num,
                deviceSerialLabel: 'Device Serial: ',
                deviceSerial: devices[i].serial,
                heartRateValue: heart_rate_value,
                heartRateAve: heart_rate_ave,
                heartRateTime: heart_rate_time,
                motionAccelSum: motion_accel_sum,
                motionAccelAve: motion_accel_ave,
                motionGravLabel: 'Motion (Gravity)',
                motionGravSum: motion_grav_sum,
                motionGravAve: motion_grav_ave,
                motionRotateSum: motion_rota_sum,
                motionRotateAve: motion_rota_ave,
                motionTime: motion_time,
                batteryLevel: battery_level,
                batteryLevelAve: battery_level_ave,
                batteryTime: battery_time,
                wifiSsid: wifi_ssid,
                wifiRssi: wifi_rssi,
                wifiTime: wifi_time
              }
              this.items.push(item)
            }
          }
        }
        this.showProgress = false
      } catch (error) {
        this.showProgress = false
        this.error = this.handleError(error)
      }
    },
    methods: {
      unixtimeAt: function(time) {
        if(time) {
          return moment(time).format("YYYY-MM-DD HH:mm:ss A")
        }
        else {
          return null
        }
      },
      async dataRefresh() {
      try {
        this.error = ''
        this.items = []
        this.showProgress = true
        var devices = (await DeviceService.index()).data
        if (devices) {
          for (var i = 0; i < devices.length; i++) {
            var b_alert = false
            var heart_rate_value = null
            var heart_rate_ave = null
            var heart_rate_time = null
            var motion_accel_sum = null
            var motion_accel_ave = null
            var motion_grav_sum = null
            var motion_grav_ave = null
            var motion_rota_sum = null
            var motion_rota_ave = null
            var motion_time = null
            var battery_level = null
            var battery_level_ave = null
            var battery_time = null
            var wifi_ssid = null
            var wifi_time = null
            var wifi_rssi = null
            var deviceheartrate = (await DeviceHeartRateService.show({deviceId: devices[i].deviceId, latest: true})).data
            var devicemotion = (await DeviceMotionService.show({deviceId: devices[i].deviceId,latest: true})).data
            var devicebattery = (await DeviceBatteryService.show({deviceId: devices[i].deviceId,latest: true})).data
            var devicewifi = (await DeviceWifiService.show({deviceId: devices[i].deviceId,latest: true})).data
            console.log('dataRefresh()--deviceId[' + devices[i].deviceIdeId + ']')
            if (deviceheartrate[0]) {
              console.log('dataRefresh()--deviceId[' + devices[i].deviceId + '],deviceheartrate[0] is not null')
              b_alert = true
              if (deviceheartrate[0].heartRate) {
                heart_rate_value = deviceheartrate[0].heartRate
              }
              if (deviceheartrate[0].createdAt) {
                heart_rate_time = deviceheartrate[0].createdAt
              }
            }
            if (devicemotion[0]) {
              console.log('dataRefresh()--deviceId[' + devices[i].deviceId + '],devicemotion[0] is not null')
              b_alert = true
              if (devicemotion[0].accelSum) {
                motion_accel_sum = devicemotion[0].accelSum
              }
              if (devicemotion[0].gravitySum) {
                motion_grav_sum = devicemotion[0].gravitySum
              }
              if (devicemotion[0].rotationSum) {
                motion_rota_sum = devicemotion[0].rotationSum
              }
              if (devicemotion[0].createdAt) {
                motion_time = devicemotion[0].createdAt
              }
            }
            if (devicebattery[0]) {
              console.log('dataRefresh()--deviceId[' + devices[i].deviceId + '],devicebattery[0] is not null')
              b_alert = true
              if (devicebattery[0].batteryLevel) {
                battery_level = devicebattery[0].batteryLevel
              }
              if (devicebattery[0].createdAt) {
                battery_time = devicebattery[0].createdAt
              }
            }
            if (devicewifi[0]) {
              console.log('dataRefresh()--deviceId[' + devices[i].deviceId + '],devicewifi[0] is not null')
              b_alert = true
              if (devicewifi[0].ssid) {
                wifi_ssid = devicewifi[0].ssid
              }
              if (devicewifi[0].rssi) {
                wifi_rssi = devicewifi[0].rssi
              }
              if (devicewifi[0].createdAt) {
                wifi_time = devicewifi[0].createdAt
              }
            }
            if (b_alert) {
              var careUserId = devices[i].careUserId
              var careuser = (await CareUserService.show({careUserId})).data
              var first_name = ''
              var last_name = ''
              var unit_num = ''
              if (careuser) {
                first_name = careuser.firstName
                last_name = careuser.lastName
                if (careuser.address) {
                  unit_num = careuser.address.unitNumber
                }
              }
              var item = {
                deviceId: devices[i].deviceId,
                residentLabel: 'Resident Name: ',
                resident:  first_name + ' ' + last_name,
                unitLabel: 'Unit: ',
                unitNum: unit_num,
                deviceSerialLabel: 'Device Serial: ',
                deviceSerial: devices[i].serial,
                heartRateValue: heart_rate_value,
                heartRateAve: heart_rate_ave,
                heartRateTime: heart_rate_time,
                motionAccelSum: motion_accel_sum,
                motionAccelAve: motion_accel_ave,
                motionGravLabel: 'Motion (Gravity)',
                motionGravSum: motion_grav_sum,
                motionGravAve: motion_grav_ave,
                motionRotateSum: motion_rota_sum,
                motionRotateAve: motion_rota_ave,
                motionTime: motion_time,
                batteryLevel: battery_level,
                batteryLevelAve: battery_level_ave,
                batteryTime: battery_time,
                wifiSsid: wifi_ssid,
                wifiRssi: wifi_rssi,
                wifiTime: wifi_time
              }
              this.items.push(item)
            }
          }
        }
        this.showProgress = false
      } catch (error) {
        this.showProgress = false
        this.error = this.handleError(error)
      }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue